
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.778 7.787h-1.971A4.469 4.469 0 0029.148.75a4.386 4.386 0 00-3.127 1.277L20 7.457l-5.985-5.4a4.469 4.469 0 00-6.822 5.73H5.222a3.069 3.069 0 00-3.065 3.065v4.925a.954.954 0 00.954.954h.454v19.455a3.067 3.067 0 003.064 3.064h26.742a3.067 3.067 0 003.064-3.064V16.731h.454a.954.954 0 00.954-.954v-4.925a3.069 3.069 0 00-3.065-3.065zm-.25 28.4a1.159 1.159 0 01-1.157 1.157H20.954V16.731h13.574zM27.335 3.409a2.569 2.569 0 011.812-.725 2.522 2.522 0 012.565 2.539 2.567 2.567 0 01-2.564 2.564h-6.667l4.845-4.369zm8.6 7.443v3.972H20.954v-5.13h13.824a1.159 1.159 0 011.157 1.158zm-16.889 5.879v20.612H6.629a1.159 1.159 0 01-1.157-1.157V16.731zM9.039 7.035a2.565 2.565 0 011.813-4.378 2.575 2.575 0 011.849.785l4.818 4.345h-6.666a2.541 2.541 0 01-1.814-.752zm-4.974 3.817a1.159 1.159 0 011.157-1.158h13.824v5.13H4.065z"}})])
          )
        }
      }
    